import React, { useState, useEffect } from "react";
import Nav from "../../../components/Nav";
import "../../../css/Home.css";
import { Link } from "react-router-dom";
import { searchEventPublic } from "../../../services/ContactPublicService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCalendarDays,
  faMapPin,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import { useAxiosInstance } from "../../../services/Interceptor";
import InputSearch from "./inputSearch";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import EventsAthleteDashboard from "../../athlete/dashboard/Events.jsx";

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const apiInstance = useAxiosInstance();
  const auth = useAuthUser();

  const loadEvents = async () => {
    setLoading(true);
    try {
      const data = await searchEventPublic(apiInstance, "");
      setEvents(data);
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadEvents();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // The events returned by the public search are already limited to today and
  // later, so their count is the number of upcoming events. When that count is
  // at or below REACT_APP_SHOW_BANNER_MAX_EVENTS there is little to show on the
  // page, so point people at Instagram for news instead. An unset or
  // non-numeric setting leaves the banner off entirely.
  const showBannerMaxEvents = Number.parseInt(
    process.env.REACT_APP_SHOW_BANNER_MAX_EVENTS,
  );
  const showInstagramBanner =
    !loading &&
    !Number.isNaN(showBannerMaxEvents) &&
    events.length <= showBannerMaxEvents;

  return (
    <>
      <Nav />
      {showInstagramBanner && (
        <div className="mt-4 flex justify-center px-4">
          <div className="flex items-center gap-2 rounded-md border border-amber-400 px-4 py-2 text-center">
            <FontAwesomeIcon icon={faInstagram} className="text-amber-300" />
            <span className="text-sm text-amber-300">
              For news about upcoming events, follow our{" "}
              <a
                href="https://www.instagram.com/trackit_verified/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline font-semibold hover:text-amber-200 transition"
              >
                Instagram page
              </a>
              .
            </span>
          </div>
        </div>
      )}
      {process.env.REACT_APP_COLLEGE_URL && (
        <div className="mt-4 mb-4 text-center flex justify-center items-center gap-2">
          <FontAwesomeIcon
            icon={faGraduationCap}
            className="text-blue-300 text-lg"
          />

          <span className="text-sm text-gray-200">
            For collegiate athletes,{" "}
            <a
              href={`${process.env.REACT_APP_COLLEGE_URL}/events`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline font-semibold hover:text-white transition"
            >
              register here
            </a>
            .
          </span>
        </div>
      )}

      <div className="flex items-center justify-center p-4">
        <div className="w-full lg:max-w-4xl p-1 lg:p-6">
          {auth && auth?.user?.role?.toLowerCase?.() === "athlete" ? (
            <EventsAthleteDashboard />
          ) : (
            <>
              <InputSearch
                setEvents={setEvents}
                setLoading={setLoading}
                loading={loading}
              />{" "}
              {/* Search Results */}
              <div className="mb-10 mt-6">
                {!loading && events.length > 0 ? (
                  events.map((event) => (
                    <div
                      key={event.id}
                      className="bg-white flex flex-row  rounded-md px-2 py-3 text-gray-800 items-center mb-3"
                    >
                      <div className="basis-1/4 text-base font-medium inline-block align-baseline text-blue-700 text-nowrap">
                        {event.date}
                      </div>
                      <div className="basis-1/2 text-base truncate px-4">
                        <p className="font-medium text-gray-800 uppercase truncate">
                          {" "}
                          {event.name}{" "}
                        </p>
                        <p className="text-gray-500 text-sm">{event.state}</p>
                      </div>
                      <div className="basis-1/4 justify-end flex ">
                        <Link
                          to={`${process.env.REACT_APP_QR_CODE_ATHLETE_REGISTER_URL}${event.id}`}
                          className="bg-red-500 text-white px-2 py-2 rounded-md uppercase text-sm"
                        >
                          Register
                        </Link>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-gray-500">No events found.</div>
                )}
              </div>
              {/* Search Results End */}
            </>
          )}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative hidden">
        <div className="grid grid-cols-4 gap-4">
          <div className="max-w-2xl mx-auto">
            <div className="bg-white shadow-md border border-neutral-500 rounded-lg max-w-sm dark:bg-gray-800 dark:border-gray-700">
              <a href="/">
                <img
                  className="rounded-lg"
                  alt="Event images"
                  src="event-img-1.webp"
                />
              </a>
              <div className="p-5">
                <a href="/">
                  <h5 className="text-gray-900 text-lg font-semibold uppercase tracking-wide">
                    Event Name here...
                  </h5>
                </a>
                <div className="grid grid-cols-2 gap-4 text-gray-400 hover:text-gray-600 mb-4 mt-1 ">
                  <div className="flex items-center text-gray-600 text-sm leading-5 mt-1">
                    <FontAwesomeIcon
                      icon={faCalendarDays}
                      className="h-4 w-4 text-gray-400 mr-1"
                    />
                    Date: 11/15/24
                  </div>
                  <div className="flex items-center text-gray-600 text-sm leading-5 mt-1">
                    <FontAwesomeIcon
                      icon={faMapPin}
                      className="h-4 w-4 text-gray-400 mr-1"
                    />
                    Highland, UT
                  </div>
                </div>
                <Link className="text-white bg-red-500 hover:bg-red-800 font-medium rounded-md uppercase text-base px-3 py-2 text-center inline-flex items-center">
                  Register
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="h-5 w-5 text-white -mr-1 ml-2"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}

export default Events;
